module.exports = __webpack_public_path__ + "static/media/quieromibarrio6.b1ceffd6.jpg";